
/* Controller Imports */
import FaultsViewDeleteController from './delete-modal/delete.controller'; 
/* Directive Imports */
import FaultsCreateDirective from './create/create.directive';                  
import FaultsListDirective from './list/list.directive';                          
import FaultsViewEditAssetsDirective from './view/assets/assets.directive';    
import FaultsViewEditDetailsDirective from './view/details/details.directive';  
import FaultsViewEditRowDirective from './view/faults/edit/edit.directive';    
import FaultsViewFaultsTabDirective from './view/faults/faults.directive';      
import FaultsViewRowDisplayDirective from './view/faults/view/view.directive'; 
/* Service Imports */
import FaultsRepo from './faults.repo';  
import FaultsService from './faults.service';   

const faultsConfigModule = angular.module('app.configFaults', [
    "ui.bootstrap",
    "ui.router",
    "gettext"
])
/* Controllers */
.controller('FaultsViewDeleteController', FaultsViewDeleteController)
/* Directives */
.directive('editFaultForm', FaultsViewEditRowDirective)
.directive('faultTable', FaultsViewFaultsTabDirective)
.directive('viewFaultForm', FaultsViewRowDisplayDirective)
.directive('createFaultConfig', FaultsCreateDirective)
.directive('editFaultAssets', FaultsViewEditAssetsDirective)
.directive('editFaultConfig', FaultsViewEditDetailsDirective)
.directive('listFaultConfig', FaultsListDirective)
/* Services */
.service('faultsRepo', FaultsRepo)
.service('faultsService', FaultsService);

export default faultsConfigModule.name;